import actionTypes, {
  getSectorAction,
  setSectorAction,
  getSectorPendingAction,
  getSectorErrorAction,
  setSelectedSectorAction,
  getModelAction,
  setModelAction,
  getModelPendingAction,
  getModelErrorAction,
  updateModelAction,
  updateModelPendingAction,
  getModelFromIndustryAction,
  setModelFromIndustryAction,
  getModelFromIndustryPendingAction,
  setMyModelAction,
  getMyModelAction,
  setSubscribeModelPendingAction,
  unSubscribePendingAction,
  unSubscribeAction,
  unSubscribeSuccess,
  unSubscribeErrorAction,
  resetStateAction,
  getUpdatedFundamentalGroupsAction,
  getUpdatedFundamentalGroupsSuccessAction,
  getUpdatedFundamentalGroupsPendingAction,
  getUpdatedFundamentalGroupsErrorAction,
  selectNotificationCompanyAction,
  getUpdatedFundamentalsAction,
  getUpdatedFundamentalsSuccessAction,
  getUpdatedFundamentalsPendingAction,
  getUpdatedFundamentalsErrorAction
} from './types';

/**
 * Sectors
 */
const getSectors: getSectorAction = () => ({
  type: actionTypes.GET_SECTORS
});

const getSectorsPending: getSectorPendingAction = () => ({
  type: actionTypes.GET_SECTORS_PENDING
});

const getSectorsError: getSectorErrorAction = (error) => ({
  type: actionTypes.GET_SECTORS_ERROR,
  error
});

const setSectors: setSectorAction = (sectors) => ({
  type: actionTypes.SET_SECTORS,
  sectors
});

const setSelectedSectors: setSelectedSectorAction = (sectorId) => ({
  type: actionTypes.SET_SELECTED_SECTOR,
  sectorId
});

/**
 * Models
 */

const getModels: getModelAction = (params) => ({
  type: actionTypes.GET_MODELS,
  params
});

const getModelsFromIndustry: getModelFromIndustryAction = (industryId, indexToInsert) => ({
  type: actionTypes.GET_MODELS_FROM_INDUSTRY,
  industryId: parseInt(industryId),
  indexToInsert
});

const getModelsFromIndustryPending: getModelFromIndustryPendingAction = (industryIdLoadMore) => ({
  type: actionTypes.GET_MODELS_FROM_INDUSTRY_PENDING,
  industryIdLoadMore
});
const getModelsPending: getModelPendingAction = () => ({
  type: actionTypes.GET_MODELS_PENDING
});

const updateModelsPending: updateModelPendingAction = () => ({
  type: actionTypes.UPDATE_MODEL_PENDING
});

const getModelsError: getModelErrorAction = (error) => ({
  type: actionTypes.GET_MODELS_ERROR,
  error
});

const setModels: setModelAction = (models, totalNumberOfIndustries) => ({
  type: actionTypes.SET_MODELS,
  models,
  totalNumberOfIndustries
});

const setModelsFromIndustry: setModelFromIndustryAction = (models) => ({
  type: actionTypes.SET_MODELS_FROM_INDUSTRY,
  models
});
const updateModels: updateModelAction = (models) => ({
  type: actionTypes.UPDATE_MODELS,
  models
});

const getMyModels: getMyModelAction = () => ({
  type: actionTypes.GET_MY_MODELS
});

const setMyModels: setMyModelAction = (clientModels) => ({
  type: actionTypes.SET_MY_MODELS,
  clientModels
});

const setSubscribeModelPending: setSubscribeModelPendingAction = (modelId) => ({
  type: actionTypes.SUBSCRIPTION_PENDING,
  modelId
});

const unSubscribeModelPending: unSubscribePendingAction = () => ({
  type: actionTypes.UNSUBSCRIBE_PENDING
});

const unSubscribeModel: unSubscribeAction = (companyId) => ({
  type: actionTypes.UNSUBSCRIBE,
  companyId
});

const unSubscribeModelSuccess: unSubscribeSuccess = () => ({
  type: actionTypes.UNSUBSCRIBE_SUCCESS
});

const unSubscribeModelError: unSubscribeErrorAction = (error) => ({
  type: actionTypes.UNSUBSCRIBE_ERROR,
  error
});

const resetState: resetStateAction = () => ({
  type: actionTypes.RESET
});

//
const getUpdatedFundamentalGroups: getUpdatedFundamentalGroupsAction = (companyId: string) => ({
  type: actionTypes.GET_UPDATED_FUNDAMENTAL_GROUPS,
  companyId
});

const getUpdatedFundamentalGroupsSuccess: getUpdatedFundamentalGroupsSuccessAction = (
  updatedFundamentalGroups
) => ({
  type: actionTypes.GET_UPDATED_FUNDAMENTAL_GROUPS_SUCCESS,
  updatedFundamentalGroups
});

const getUpdatedFundamentalGroupsPending: getUpdatedFundamentalGroupsPendingAction = () => ({
  type: actionTypes.GET_UPDATED_FUNDAMENTAL_GROUPS_PENDING
});

const getUpdatedFundamentalGroupsError: getUpdatedFundamentalGroupsErrorAction = () => ({
  type: actionTypes.GET_UPDATED_FUNDAMENTAL_GROUPS_ERROR
});

const selectNotificationCompany: selectNotificationCompanyAction = (company) => ({
  type: actionTypes.SELECT_NOTIFICATION_COMPANY,
  company
});

const getUpdatedFundamentals: getUpdatedFundamentalsAction = (
  companyId: string,
  groupId: string
) => ({
  type: actionTypes.GET_UPDATED_FUNDAMENTALS,
  companyId,
  groupId
});

const getUpdatedFundamentalsSuccess: getUpdatedFundamentalsSuccessAction = (
  updatedFundamentals,
  groupId
) => ({
  type: actionTypes.GET_UPDATED_FUNDAMENTALS_SUCCESS,
  updatedFundamentals,
  groupId
});

const getUpdatedFundamentalsPending: getUpdatedFundamentalsPendingAction = (groupId) => ({
  type: actionTypes.GET_UPDATED_FUNDAMENTALS_PENDING,
  groupId
});

const getUpdatedFundamentalsError: getUpdatedFundamentalsErrorAction = () => ({
  type: actionTypes.GET_UPDATED_FUNDAMENTALS_ERROR
});

const stopPolling = () => ({ type: actionTypes.STOP_POLLING });

export default {
  getSectors,
  getSectorsPending,
  getSectorsError,
  setSectors,
  setSelectedSectors,
  getModels,
  getModelsPending,
  getModelsError,
  setModels,
  updateModels,
  updateModelsPending,
  setModelsFromIndustry,
  getModelsFromIndustry,
  getModelsFromIndustryPending,
  getMyModels,
  setMyModels,
  setSubscribeModelPending,
  unSubscribeModel,
  unSubscribeModelPending,
  unSubscribeModelSuccess,
  unSubscribeModelError,
  resetState,
  getUpdatedFundamentalGroups,
  getUpdatedFundamentalGroupsSuccess,
  getUpdatedFundamentalGroupsPending,
  getUpdatedFundamentalGroupsError,
  selectNotificationCompany,
  getUpdatedFundamentals,
  getUpdatedFundamentalsSuccess,
  getUpdatedFundamentalsPending,
  getUpdatedFundamentalsError,
  stopPolling
};
